<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_3939_3981)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M8.54968 9.12686C8.54968 9.5963 8.93024 9.97686 9.39968 9.97686L14.15 9.97686V20.8731C14.15 21.3426 14.5306 21.7231 15 21.7231C15.4695 21.7231 15.85 21.3426 15.85 20.8731V9.97686L20.6004 9.97686C21.0699 9.97686 21.4504 9.5963 21.4504 9.12686C21.4504 8.65741 21.0699 8.27686 20.6004 8.27686L9.39968 8.27686C8.93024 8.27686 8.54968 8.65741 8.54968 9.12686Z" fill="currentColor"/>
</g>
<defs>
<clipPath id="clip0_3939_3981">
<rect width="22" height="22" fill="white" transform="translate(4 4)"/>
</clipPath>
</defs>
</svg>
